module.exports = __webpack_public_path__ + "static/enter-your-data-20cf7af2012254b4c121d0212e60ca7d.png";